export default __webpack_public_path__ + "static/media/accio.6a19516d.gif";